import React from "react";
import { useLocation } from "react-router-dom";
import { Plus, Check } from "react-feather";
import toast from "react-hot-toast";
import { resolvePageMeta } from "../../features/quickMenu/resolvePageMeta";
import {
  useListQuickMenuItemsQuery,
  usePinPageMutation,
  useUnpinPageMutation,
} from "../../features/quickMenu/quickMenuApi";

// Floating "+"/pinned toggle, mounted once (sibling to FeedbackWidget) so it
// persists across route changes and always reflects the current page. Sits
// directly above the Feedback widget's 56px button (20px gap), same fixed-
// positioning convention.
const QuickPinButton = () => {
  const location = useLocation();
  const meta = resolvePageMeta(location.pathname);
  const { data: items = [] } = useListQuickMenuItemsQuery();
  const [pinPage, { isLoading: isPinning }] = usePinPageMutation();
  const [unpinPage, { isLoading: isUnpinning }] = useUnpinPageMutation();

  if (!meta) return null;

  const pinned = items.find((i) => i.pagePath === location.pathname);
  const isBusy = isPinning || isUnpinning;

  const handleClick = async () => {
    try {
      if (pinned) {
        await unpinPage(pinned.quickMenuItemId).unwrap();
        toast.success("Removed from Quick Menu");
      } else {
        await pinPage({ pagePath: location.pathname, pageLabel: meta.label, pageIcon: meta.iconName }).unwrap();
        toast.success("Added to Quick Menu");
      }
    } catch (error) {
      toast.error(error?.message || "Could not update your Quick Menu");
    }
  };

  return (
    <div style={{ position: "fixed", right: 20, bottom: 88, zIndex: 1050 }}>
      <button
        type="button"
        className={`btn ${pinned ? "btn-success" : "btn-primary"} rounded-circle shadow d-flex align-items-center justify-content-center`}
        style={{ width: 56, height: 56 }}
        onClick={handleClick}
        disabled={isBusy}
        title={pinned ? "Remove from Quick Menu" : "Add to Quick Menu"}
      >
        {pinned ? <Check size={22} /> : <Plus size={22} />}
      </button>
    </div>
  );
};

export default QuickPinButton;
